<template>
  <div>
    <FloatingButtonMenu :menu="[
      {
        icon: 'event_note',
        name: 'EVENT\nLOG',
        component: 'static',
      },
    ]" @select="openEventLogHandler" />

    <EventLogDialog v-model="isEventLogOpen" :plant-id="getSelectedPlantId" :has-both-device-types="hasBothDeviceTypes"
      :default-device-type="activeControlDevice.device_type" />

    <v-dialog v-model="isPasswordDialogOpen" persistent max-width="30%">
      <Card class="pa-3">
        <v-card-title class="title pa-2 justify-center">{{ $t("Enter the Password") }}
        </v-card-title>
        <v-divider></v-divider>
        <v-form class="pa-2">
          {{ $t("Email") }}
          <v-text-field class="pa-0" v-model="userEmail" autocomplete="email"></v-text-field>
          {{ $t("Password") }}
          <v-text-field class="pa-0" type="password" v-model="password" autocomplete="new-password" required>
          </v-text-field>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="error" @click="isPasswordDialogOpen = false">{{
              $t("Cancel")
            }}</v-btn>
            <v-btn class="success" @click="
              verifyPassword(userEmail, password);
            isPasswordDialogOpen = false;
            ">
              {{ $t("OK") }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </Card>
    </v-dialog>

    <v-dialog v-model="isConfirmationDialogOpen" persistent origin="center top" max-width="40%" class="dialog">
      <Card class="pa-3">
        <v-card-title class="subheading">{{ $t("Are you sure you want to submit?") }}</v-card-title>
        <v-card-actions class="justify-end">
          <v-btn color="success" v-on:click="
            executeControlAction();
          isConfirmationDialogOpen = false;
          ">
            {{ $t("YES") }}</v-btn>
          <v-btn color="error" @click="isConfirmationDialogOpen = false">{{
            $t("NO")
          }}</v-btn>
        </v-card-actions>
      </Card>
    </v-dialog>

    <div v-if="groupedDevices.length > 0" class="relay-container">
      <div class="relay-item my-1" v-for="itemList in groupedDevices" :key="itemList.device_id">
        <Card class="relay-item-card my-1 px-2 pb-3">
          <div class="subheading text-xs-center px-2">
            {{
              !itemList.isVcbOnly
                ? itemList.name
                : (itemList.deviceList &&
                  itemList.deviceList.length > 0 &&
                  itemList.deviceList[0].name)
            }}
          </div>
          <v-flex xs12 pb-1 ma-0>
            <v-divider />
          </v-flex>
          <div class="relay-vcb-list mx-3" v-if="itemList.deviceList && itemList.deviceList.length > 0">
            <div class="md-3 lg-3 custom-border" v-for="item in itemList.deviceList" :key="item.device_id">
              <Card class="pa-3" :background="'bg'">
                <v-layout row wrap justify-center align-center>
                  <v-flex xs12 class="text-xs-center pa-0 ma-0">
                    <div class="mb-3">
                      Selected switch mode:
                      {{ vcbSwitchMode[item.device_id] }}
                    </div>
                    <v-divider class="custom-divider"></v-divider>
                  </v-flex>
                  <v-flex xs3>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <img v-bind="attrs" v-on="on"
                          :class="vcbConnected[item.etilog_id] ? 'connected_icon' : 'disconnected_icon'"
                          :src="getConnectionIcon(vcbConnected[item.etilog_id])" width="98%" />
                      </template>
                      <span>
                        {{ vcbConnected[item.etilog_id] ? `Connected to: ${item.etilog_id}` : `Couldn't connect to:
                        ${item.etilog_id}` }}
                      </span>
                    </v-tooltip>
                  </v-flex>
                  <v-flex xs9>
                    <v-layout row wrap>
                      <v-flex class="text-xs-center pt-3 pb-0 mb-0" xs12>
                        <span class="subheading">
                          {{ item.name }}
                        </span>
                      </v-flex>
                      <v-flex class="text-xs-center pt-0 pb-2 mb-0 mt-0" xs12>
                        <span class="caption">
                          {{
                            vcbConnected[item.etilog_id]
                              ? $t("Connection Established")
                              : $t("Connection Lost")
                          }}</span>
                      </v-flex>
                      <v-flex>
                        <a href="#" :id="`${item.device_id}-${item.name}`" class="toggle"
                          :class="vcbToggleClassMap[item.device_id]" 
                          @click="(e) => handleVcbToggle(e, item)"></a>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </Card>
            </div>
          </div>
          <v-divider v-if="itemList.deviceList && itemList.deviceList.length > 0" class="mt-2" />
          <div class="px-2 pt-2 pb-0 ma-0" v-if="!itemList.isVcbOnly">
            <v-layout row pa-0 ma-0>
              <img :class="relayConnected[itemList.etilog_id] ? 'connected_icon' : 'disconnected_icon'"
                :src="getConnectionIcon(relayConnected[itemList.etilog_id])" width="50" class="ml-3 mb-4 pb-2" />
              <v-flex xs5 pa-0 ma-0 mr-3 ml-3>
                <v-select v-model="selectedParametersByRelay[itemList.device_id]"
                  :items="mappedRelayParameters[itemList.device_id]" :label="`Select Parameters for ${itemList.name}`"
                  multiple outline color="accent" menu-props="offset-y" class="param-select" attach>
                  <template slot="prepend-item">
                    <v-list-tile ripple @click="toggleSelectAllForRelay(itemList.device_id)">
                      <v-list-tile-action>
                        <v-icon color="accent">
                          {{ (selectedParametersByRelay[itemList.device_id] || []).length === (mappedRelayParameters[itemList.device_id] || []).length ? 'mdi-close-box' : 'mdi-checkbox-blank-outline' }}
                        </v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          {{ (selectedParametersByRelay[itemList.device_id] || []).length === (mappedRelayParameters[itemList.device_id] || []).length ? $t("Deselect All") : $t("Select All") }}
                        </v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider class="mt-2"></v-divider>
                  </template>
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index < 4" :key="item.value" @input="removeItem(item, itemList.device_id)"
                      class="chip-selection">
                      {{ item.text }}
                    </v-chip>
                    <span v-if="index === 4" class="grey--text caption">
                      (+{{ selectedParametersByRelay[itemList.device_id].length - 4 }} {{ $t("others") }})
                    </span>
                  </template>
                </v-select>
              </v-flex>
              <v-flex shrink ma-0 style="flex: 0 0 auto; width: auto;">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      <v-btn color="accent" class="submit-btn mt-2" @click="submitParams(itemList.device_id)"
                        :disabled="relaySubmitDisabledMap[itemList.device_id]">
                        {{ $t('SUBMIT') }}
                      </v-btn>
                    </div>
                  </template>
                  <span>
                    {{ relayConnected[itemList.etilog_id] ? `Connected to: ${itemList.etilog_id}` : `Couldn't connect:
                    ${itemList.etilog_id}` }}
                  </span>
                </v-tooltip>
              </v-flex>
            </v-layout>
          </div>
          <div class="relay-content-wrapper mx-2" v-if="
            parameterCardsByRelay[itemList.device_id] &&
            parameterCardsByRelay[itemList.device_id].length > 0
          ">
            <div outlined v-for="(item, index) in parameterCardsByRelay[itemList.device_id]"
              :key="`${itemList.device_id}-${item.parameter}`" class="param-card lg2 md-4 sm-6 xs12 mx-2 my-2" :class="{
                'param-card-error':
                  parameterErrors[`${itemList.device_id}-${item.parameter}`],
              }">
              <v-card-text class="param-card-text text-xs-center pa-4">
                <div class="param-title font-weight-bold mb-2">
                  {{ item.label }}
                </div>

                <div class="param-range mb-3">
                  <span class="range-text">Min: {{ item.minValue }}</span>
                  <span class="range-divider">|</span>
                  <span class="range-text">Max: {{ item.maxValue }}</span>
                </div>
                <v-text-field v-model="item.value" label="User Input Value" outlined type="number" color="success"
                  :disabled="!relayConnected[itemList.etilog_id]" dense
                  class="param-input mb-2" @input="val => handleParamInput(val, item, itemList.device_id)"
                  :error="!!parameterErrors[`${itemList.device_id}-${item.parameter}`]" 
                  :error-messages="getParamError(itemList.device_id, item.parameter)"
                  :rules="[v=> {
                    const num = Number(v);
                    if (isNaN(num)) {
                      return 'Value must be a number';
                    }
                    if (num < item.minValue || num > item.maxValue) {
                      return `Value must be between ${item.minValue} and ${item.maxValue}`;
                    }
                    return true;
                  }]"
                  @focus="item.isUserEditing = true" @blur="item.isUserEditing = false"
                  @mouseenter="item.isUserEditing = true" @mouseleave="item.isUserEditing = false" />
                <v-layout row justify-center align-center class="mt-3 button-container">
                  <v-btn x-small color="warning" class="mr-2" @click="resetParameter(itemList.device_id, index)"
                    :disabled="!item.isModified">
                    <v-icon x-small>refresh</v-icon>
                    Reset
                  </v-btn>
                  <v-btn x-small color="error" @click="removeParameter(itemList.device_id, index)">
                    <v-icon x-small>close</v-icon>
                    Remove
                  </v-btn>
                </v-layout>
              </v-card-text>
            </div>
          </div>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
const moment = require("moment");
import { mapGetters, mapMutations, mapActions } from "vuex";
import { mapGettersMixin } from "@/util/mixin/index";
import Controlling from "@/services/Controlling";
const FloatingButtonMenu = () =>
  import("@/components/common/FloatingButtonMenu");
const EventLogDialog = () => import("./components/EventLogDialog");

export default {
  components: {
    FloatingButtonMenu,
    EventLogDialog
  },
  mixins: [mapGettersMixin],
  data() {
    return {
      vcbList: [],
      vcbConnected: {},
      vcbStatus: {},
      vcbSwitchMode: {},
      isPasswordDialogOpen: false,
      isConfirmationDialogOpen: false,
      isEventLogOpen: false,
      userEmail: "",
      password: "",
      activeControlDevice: {},
      relayList: [],
      relayNames: {},
      relayConnected: {},
      submittedRelays: {},
      relayLiveData: {},
      parameterErrors: {},
      selectedParametersByRelay: {},
      parameterCardsByRelay: {},
      modifiedParametersByRelay: {},
      submittedParameters: new Set(),
      pendingRelayParameterSubmission: null,
      submitEnabledByRelay: {},
      modifiedCardsByRelay: {},
    };
  },
  computed: {
    ...mapGetters(["getUserInfo", "getSelectedPlantId"]),
    today() {
      return moment().format("YYYY-MM-DD");
    },
    hasBreakerList() {
      return Array.isArray(this.vcbList) && this.vcbList.length > 0;
    },
    hasRelayList() {
      return Array.isArray(this.relayList) && this.relayList.length > 0;
    },
    hasBothDeviceTypes() {
      const hasRelay = this.hasRelayList;
      const hasVcb = this.hasBreakerList;
      return hasRelay && hasVcb;
    },
    groupedDevices() {
      if (this.relayList.length > 0) {
        const vcbMap = new Map();
        this.vcbList.forEach(v => {
          const parts = v.device_id.split('-');
          if (parts.length > 1) {
            const key = `${parts[0]}-${parts[1]}`;
            if (!vcbMap.has(key)) vcbMap.set(key, []);
            vcbMap.get(key).push(v);
          }
        });

        return this.relayList.map(relay => {
          const r = { ...relay, deviceList: [] };
          const relayIdParts = r.device_id.split('-');
          if (relayIdParts.length > 2) {
            const key = `${relayIdParts[0]}-${relayIdParts[2]}`;
            r.deviceList = vcbMap.get(key) || [];
          }
          return r;
        });
      }
      if (this.vcbList.length > 0) {
        return this.vcbList.map(v => ({
          device_id: v.device_id,
          device_name: v.device_name,
          deviceList: [v],
          isVcbOnly: true
        }));
      }
      return [];
    },
    mappedRelayParameters() {
      const map = {};
      this.relayList.forEach(relay => {
        if (relay.params) {
          map[relay.device_id] = Object.entries(relay.params).map(([key, param]) => ({
            text: param.label || key,
            value: key
          }));
        } else {
          map[relay.device_id] = [];
        }
      });
      return map;
    },
    vcbToggleClassMap() {
      const map = {};
      this.vcbList.forEach((item) => {
        const isConnected = this.vcbConnected[item.etilog_id];
        const status = this.vcbStatus[item.device_id];
        const isOn = status === 1;

        let classes = isOn ? "toggle--on" : "toggle--off";

        if (!isConnected) {
          classes += " disabled";
        }
        map[item.device_id] = classes;
      });
      return map;
    },
    relaySubmitDisabledMap() {
      const map = {};
      this.relayList.forEach((relay) => {
        const relayId = relay.device_id;
        const cards = this.parameterCardsByRelay[relayId] || [];
        const hasModified = cards.some((card) => card.isModified === true);

        if (!hasModified) {
          map[relayId] = true;
        } else {
          const prefix = `${relayId}-`;
          const hasError = Object.keys(this.parameterErrors).some((key) =>
            key.startsWith(prefix)
          );
          map[relayId] = hasError;
        }
      });
      return map;
    },
  },
  async mounted() {
    this.userEmail = this.getUserInfo("email");
    this.listenToMqttTopics();

    await this.getVcbList();
    await this.getVcbSwitchMode();
    await this.getRelayList();
  },
  beforeDestroy() {
    this.unsubscribeToTopics();
  },
  methods: {
    ...mapActions([
      "validateUserAction"
    ]),
    ...mapMutations([
      "SET_SHOW_SNACKBAR",
      "SET_SNACKBAR_CONTENT",
      "SET_PROGRESS_BAR",
    ]),
    async openEventLogHandler() {
      this.isEventLogOpen = true;
    },
    enableRelaySubmit(relayId) {
      this.$set(this.submitEnabledByRelay, relayId, true);
    },
    listenToMqttTopics() {
      this.$mqtt.subscribe(`live/${this.getSelectedPlantId}/relay`);
      this.$mqtt.subscribe(`control_feedback/${this.getSelectedPlantId}/#`);
      this.$mqtt.subscribe(`epicConnection/${this.getSelectedPlantId}`);
      this.$mqtt.subscribe(`live/${this.getSelectedPlantId}/breaker`);
      this.$mqtt.subscribe(
        `control/state_change/${this.getSelectedPlantId}/breaker`
      );

      this.$mqtt.on("message", this.handleMqttMessage);
    },
    async handleMqttMessage(topic, message) {
      try {
        const payload = JSON.parse(message.toString());

        if (topic === `live/${this.getSelectedPlantId}/relay`) {
          this.handleRelayLiveData(payload);
        } else if (topic == `epicConnection/${this.getSelectedPlantId}`) {
          const { status, epicId } = payload;
          this.$set(this.vcbConnected, epicId, status);
          this.$set(this.relayConnected, epicId, status);
        } else if (
          topic.startsWith(`control_feedback/${this.getSelectedPlantId}`)
        ) {
          this.handleControlFeedback(payload);
        } else if (topic.startsWith("live/") && topic.endsWith("breaker")) {
          this.handleBreakerLiveData(payload);
        } else if (topic.startsWith("control/state_change/")) {
          this.handleStateChange(payload);
        }
      } catch (e) {
        console.error("Error handling MQTT message:", e);
      }
    },
    handleControlFeedback(payload) {
      const { device_type } = payload;
      if (device_type == "breaker") {
        this.handleBreakerFeedback(payload);
      } else if (device_type == "relay") {
        this.handleRelayFeedback(payload);
      }
    },
    handleBreakerFeedback(payload) {
      let { device_name, device_id, status } = payload;

      if (this.activeControlDevice.device_id != device_id) {
        return;
      }

      let param = {
        plant_id: this.getSelectedPlantId,
        device_id,
        device_type: "breaker",
        category: this.activeControlDevice.category,
        device_name,
        updated_by: this.userEmail,
      };

      let snackbarContent = {
        icon: "",
        header: "",
        message: "",
      };

      if (
        status &&
        ((typeof status == "boolean" && status) ||
          (Array.isArray(status) && status[0] == "true"))
      ) {
        param["prev_status"] = this.vcbStatus[device_id];
        param["current_status"] = this.vcbStatus[device_id] == 1 ? 0 : 1;
        param["request_status"] = "success";
        snackbarContent.icon = "success";
        snackbarContent.message = this.$t("Successfully updated the status");
      } else {
        param["prev_status"] = this.vcbStatus[device_id];
        param["current_status"] = this.vcbStatus[device_id];
        param["request_status"] = "failure";
        snackbarContent.icon = "error";
        snackbarContent.message = this.$t("Failed to update the status");
      }

      this.SET_SNACKBAR_CONTENT(snackbarContent);
      this.SET_SHOW_SNACKBAR(true);

      this.insertLog(param);
    },
    handleRelayFeedback(payload) {
      const { device_id, device_name } = payload;
      const pendingItems = this.pendingRelayParameterSubmission
        ? this.pendingRelayParameterSubmission[device_id]
        : null;

      if (!pendingItems || pendingItems.length === 0) {
        return;
      }

      let processedIndices = [];
      let messages = [];

      pendingItems.forEach((item, index) => {
        const card = item.card;
        const paramKey = card.parameter;

        if (payload.hasOwnProperty(paramKey)) {
          const val = payload[paramKey];
          let statusStr = null;

          if (
            (typeof val == "boolean" && val) ||
            (Array.isArray(val) && val[0] == "true")
          ) {
            statusStr = "success";
          } else if (
            (typeof val == "boolean" && !val) ||
            (Array.isArray(val) && val[0] == "false")
          ) {
            statusStr = "failure";
          }

          if (statusStr) {
            const param = {
              plant_id: this.getSelectedPlantId,
              device_id,
              device_type: "relay",
              category: "relay",
              parameter: {
                [paramKey]: {
                  prev_value: item.prevValue,
                  current_value: item.currentValue,
                  request_status: statusStr,
                },
              },
              device_name,
              updated_by: this.userEmail,
            };

            this.insertLog(param);
            messages.push(
              `${card.label}: ${statusStr === "success" ? "Updated successfully" : "Update failed"
              }`
            );
            processedIndices.push(index);
          }
        }
      });

      if (processedIndices.length > 0) {
        const snackbarContent = {
          icon: "notification",
          header: "",
          message: "Relay parameters updated successfully."
        };
        this.SET_SNACKBAR_CONTENT(snackbarContent);
        this.SET_SHOW_SNACKBAR(true);

        const remaining = pendingItems.filter(
          (_, i) => !processedIndices.includes(i)
        );
        if (remaining.length === 0) {
          this.$delete(this.pendingRelayParameterSubmission, device_id);
        } else {
          this.$set(this.pendingRelayParameterSubmission, device_id, remaining);
        }
      }
    },
    handleBreakerLiveData(payload) {
      const mqttData = payload.deviceList ? payload.deviceList[0] : null;
      if (mqttData && !mqttData.exception) {
        const index = this.vcbList.findIndex(
          (el) => el.device_id == mqttData["device_id"]
        );

        if (index >= 0) {
          let mode = "";
          if (mqttData.remote == 1 && mqttData.local == 0) {
            mode = "Remote";
          } else if (
            (mqttData.remote == 0 && mqttData.local == 1) ||
            (mqttData.remote == 1 && mqttData.local == 1)
          ) {
            mode = "Local";
          } else if (mqttData.remote == null && mqttData.local == null) {
            mode = "N/A";
          }
          this.$set(this.vcbSwitchMode, mqttData["device_id"], mode);
        }
      }
    },
    handleStateChange(payload) {
      const { device_id, device_type, state } = payload;
      if (device_type == "breaker") {
        this.$set(this.vcbStatus, device_id, state);
      }
    },
    unsubscribeToTopics() {
      this.$mqtt.unsubscribe(`control_feedback/${this.getSelectedPlantId}/#`);
      this.$mqtt.unsubscribe(`epicConnection/${this.getSelectedPlantId}`);
      this.$mqtt.unsubscribe(`live/${this.getSelectedPlantId}/breaker`);
      this.$mqtt.unsubscribe(
        `control/state_change/${this.getSelectedPlantId}/breaker`
      );
      this.$mqtt.unsubscribe(`live/${this.getSelectedPlantId}/relay`);
    },
    handleVcbClick(deviceDetail) {
      if (this.vcbSwitchMode[deviceDetail.device_id] == "Local") {
        let payload = {
          icon: "error",
          header: "",
          message: this.$t("Operation not allowed!"),
        };
        this.SET_SNACKBAR_CONTENT(payload);
        this.SET_SHOW_SNACKBAR(true);
        return;
      }

      this.activeControlDevice = {
        name: deviceDetail.name,
        etilog_id: deviceDetail.etilog_id,
        device_id: deviceDetail.device_id,
        device_type: deviceDetail.device_type,
        category: deviceDetail.category,
        interface: deviceDetail.device_interface,
        value: Number(!!!this.vcbStatus[deviceDetail.device_id]),
      };

      if (this.vcbConnected[deviceDetail.etilog_id]) {
        this.isPasswordDialogOpen = true;
      } else {
        let payload = {
          icon: "error",
          header: "",
          message: this.$t("Sorry Connection Lost with Device"),
        };
        this.SET_SNACKBAR_CONTENT(payload);
        this.SET_SHOW_SNACKBAR(true);
      }
    },
    async verifyPassword(email, password) {
      this.userEmail = email;
      this.password = password;

      if (password.length <= 1) {
        let payload = {
          icon: "error",
          header: "",
          message: this.$t("Username or password entered is incorrect"),
        };
        this.SET_SNACKBAR_CONTENT(payload);
        this.SET_SHOW_SNACKBAR(true);

        return;
      }

      try {
        await this.validateUserAction({
          email,
          password,
        })
        if (this.pendingRelayParameterSubmission) {
          this.isConfirmationDialogOpen = true;
        } else if (this.activeControlDevice && this.activeControlDevice.etilog_id) {
          if (this.vcbConnected[this.activeControlDevice.etilog_id]) {
            this.isConfirmationDialogOpen = true;
          } else {
            let payload = {
              icon: "error",
              header: "",
              message: this.$t("Sorry Connection Lost with Device"),
            };
            this.SET_SNACKBAR_CONTENT(payload);
            this.SET_SHOW_SNACKBAR(true);
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    executeControlAction() {
      if (this.hasRelayList && this.pendingRelayParameterSubmission && Object.keys(this.pendingRelayParameterSubmission).length > 0) {
          this.submitRelayParameters();
        return;
      } else if (this.hasBreakerList) {
        const { name, etilog_id, device_id, device_type, value } = this.activeControlDevice;

        const blockPath = device_id.split("-").join("/");
        this.topicValue = `control/${this.getSelectedPlantId}/${etilog_id}/${device_type}/${blockPath}`;

        const msg = {
          plant_id: this.getSelectedPlantId,
          device_id,
          device_name: name,
          device_type,
          status: Number(value),
        };

        this.$mqtt.publish(this.topicValue, JSON.stringify(msg));
        return;
      }
    },
    async getRelayList() {
      const response = await Controlling.getRelayList(this.getSelectedPlantId);

      this.relayList = response.data.message;

      this.relayList.forEach(relay => {
        this.$set(this.relayNames, relay.device_id, relay.device_name);
        this.$set(this.selectedParametersByRelay, relay.device_id, []);
        this.$set(this.parameterCardsByRelay, relay.device_id, []);
        this.$set(this.modifiedParametersByRelay, relay.device_id, new Set());

        const relayEtilogId = relay.etilog_id;
        if (relayEtilogId) {
          this.$set(this.relayConnected, relayEtilogId, relay.apic_connected);
        }
      });
    },
    toggleSelectAllForRelay(relayDeviceId) {
      const params = this.mappedRelayParameters[relayDeviceId] || [];
      const currentSelection = this.selectedParametersByRelay[relayDeviceId] || [];

      if (currentSelection.length === params.length) {
        this.$set(this.selectedParametersByRelay, relayDeviceId, []);
      } else {
        this.$set(this.selectedParametersByRelay, relayDeviceId, params.map(p => p.value));
      }

      this.createParameterCardsForRelay(relayDeviceId);
    },
    createParameterCardsForRelay(relayDeviceId) {
      const selectedParams = this.selectedParametersByRelay[relayDeviceId] || [];
      const relay = this.relayList.find(r => r.device_id === relayDeviceId);

      if (!relay || !relay.params) {
        this.$set(this.parameterCardsByRelay, relayDeviceId, []);
        return;
      }

      const oldValueMap = {};
      (this.parameterCardsByRelay[relayDeviceId] || []).forEach(card => {
        oldValueMap[card.parameter] = card;
      });

      const newCards = selectedParams.map(paramKey => {
        const paramDetail = relay.params[paramKey];
        if (!paramDetail) return null;

        const existing = oldValueMap[paramKey];
        const range = paramDetail.range || {};

        return {
          parameter: paramKey,
          label: paramDetail.label || paramKey,
          value: existing ? existing.value : '',
          minValue: range.min_range !== undefined ? Number(range.min_range) : 0,
          maxValue: range.max_range !== undefined ? Number(range.max_range) : 100,
          relayId: relayDeviceId,
          relayName: relay.device_name,
          liveValue: existing ? existing.liveValue : undefined,
          lastValue: existing ? existing.lastValue : '',
          lastUpdated: existing ? existing.lastUpdated : null,
          isModified: existing ? existing.isModified : false,
          isUserEditing: false,
        };
      }).filter(card => card !== null);

      this.$set(this.parameterCardsByRelay, relayDeviceId, newCards);
    },
    handleRelayLiveData(payload) {
      if (payload.deviceList && Array.isArray(payload.deviceList)) {
        payload.deviceList.forEach(relay => {
          const incomingDeviceId = relay.deviceId || relay.device_id;

          if (!incomingDeviceId) return;
          const relayId = this.mapIncomingDeviceIdToRelayId(incomingDeviceId);

          if (!relayId) return;

          const params = { ...relay };
          const etilogId = relay.etilog_id || relay.etilogId;

          this.$set(this.relayLiveData, relayId, {
            device_id: relayId,
            etilog_id: etilogId,
            device_name: relay.device_name || this.relayNames[relayId],
            sensorTime: payload.sensorTime || relay.sensor_time,
            params
          });

          this.updateLiveDataForRelay(
            relayId,
            params,
            relay.device_name || this.relayNames[relayId]
          );
        });
      }
    },
    mapIncomingDeviceIdToRelayId(incomingDeviceId) {
      const incomingParts = incomingDeviceId.split('-');
      if (incomingParts.length < 2) return null;

      const blockId = incomingParts[0];
      const relayIdFromIncoming = incomingParts[incomingParts.length - 1];
      const relay = this.relayList.find(r => {
        const parts = r.device_id.split('-');
        return parts.length === 3 &&
          parts[0] === blockId &&
          parts[2] === relayIdFromIncoming;
      });

      return relay ? relay.device_id : null;
    },
    updateLiveDataForRelay(relayId, params, relayName) {
      if (!params) return;

      const cardsForRelay = this.parameterCardsByRelay[relayId] || [];

      cardsForRelay.forEach(card => {
        const paramKey = card.parameter.toLowerCase().replace(/ /g, '_');
        if (params[paramKey] !== undefined) {
          const liveValue = params[paramKey];
          card.liveValue = liveValue;
          card.lastUpdated = moment().unix();

          if (!card.isUserEditing && !card.isModified) {
            card.value = String(liveValue);
          }
        }
      });
    },
    removeParameter(relayId, index) {
      const cards = this.parameterCardsByRelay[relayId] || [];
      const paramName = cards[index].parameter;

      const selected = this.selectedParametersByRelay[relayId] || [];
      this.$set(this.selectedParametersByRelay, relayId,
        selected.filter(p => p !== paramName));

      cards.splice(index, 1);

      delete this.parameterErrors[`${relayId}-${paramName}`];

      if (this.modifiedParametersByRelay[relayId]) {
        this.modifiedParametersByRelay[relayId].delete(paramName);
      }
    },
    resetParameter(relayId, index) {
      const cards = this.parameterCardsByRelay[relayId] || [];
      const card = cards[index];

      if (!card) return;
      card.value = card.liveValue !== undefined ? String(card.liveValue) : '';
      card.isModified = false;
      card.hasError = false;
      delete this.parameterErrors[`${relayId}-${card.parameter}`];
      if (this.modifiedParametersByRelay[relayId]) {
        this.modifiedParametersByRelay[relayId].delete(card.parameter);
      }
      this.$set(this.parameterCardsByRelay, relayId, [...cards]);
    },
    validateParameterValue(paramKey, value) {
      let card = null;
      let relayId = null;

      for (let rId in this.parameterCardsByRelay) {
        const cards = this.parameterCardsByRelay[rId] || [];
        const foundCard = cards.find(c => `${rId}-${c.parameter}` === paramKey);
        if (foundCard) {
          card = foundCard;
          relayId = rId;
          break;
        }
      }

      if (!card || !relayId) return true;

      const numValue = parseFloat(value);

      if (value !== '' && value !== null && value !== undefined) {
        if (isNaN(numValue)) {
          this.$set(this.parameterErrors, paramKey, "Please enter a valid number");
          return false;
        }

        if (numValue < card.minValue) {
          this.$set(this.parameterErrors, paramKey, `Value must be >= ${card.minValue}`);
          return false;
        }

        if (numValue > card.maxValue) {
          this.$set(this.parameterErrors, paramKey, `Value must be <= ${card.maxValue}`);
          return false;
        }
      }
      this.$delete(this.parameterErrors, paramKey);
      return true;
    },
    submitParams(relayId) {
      const cards = this.parameterCardsByRelay[relayId] || [];

      const filledCards = cards.filter(card =>
        card.value !== '' &&
        card.value !== null &&
        card.value !== undefined &&
        card.isModified === true
      );

      if (filledCards.length === 0) {
        const snackbarContent = {
          icon: "error",
          header: "",
          message: "Please fill in at least one parameter value",
        };
        this.SET_SNACKBAR_CONTENT(snackbarContent);
        this.SET_SHOW_SNACKBAR(true);
        return;
      }
      let hasErrors = false;
      filledCards.forEach(card => {
        const paramKey = `${relayId}-${card.parameter}`;
        if (!this.validateParameterValue(paramKey, card.value)) {
          hasErrors = true;
        }
      });

      if (hasErrors) {
        const errorMessages = Object.keys(this.parameterErrors)
          .filter(key => key.startsWith(relayId + "-"))
          .map(key => this.parameterErrors[key])
          .join(", ");

        const snackbarContent = {
          icon: "error",
          header: "",
          message: `Validation Error: ${errorMessages}`,
        };
        this.SET_SNACKBAR_CONTENT(snackbarContent);
        this.SET_SHOW_SNACKBAR(true);
        return;
      }
      this.pendingRelayParameterSubmission = {
        [relayId]: filledCards.map(card => ({
          card,
          prevValue: card.liveValue,
          currentValue: card.value
        })),
      };

      this.isPasswordDialogOpen = true;
    },
    submitRelayParameters() {
      if (!this.pendingRelayParameterSubmission || Object.keys(this.pendingRelayParameterSubmission).length === 0) {
        const snackbarContent = {
          icon: "error",
          header: "",
          message: "No parameters to submit",
        };
        this.SET_SNACKBAR_CONTENT(snackbarContent);
        this.SET_SHOW_SNACKBAR(true);
        return;
      }

      const relaysToSubmit = this.pendingRelayParameterSubmission;

      for (let relayId in relaysToSubmit) {
        const items = relaysToSubmit[relayId];
        const relay = this.relayList.find(r => r.device_id === relayId);

        if (!relay) continue;

        let payload = {
          timestamp: moment().unix(),
          plant_id: this.getSelectedPlantId,
          device_id: relayId,
          device_name: relay.device_name || relay.name,
          device_type: 'relay',
          updated_by: this.getUserInfo("email")
        };
        items.forEach(item => {
          const card = item.card;

          payload[card.parameter] = Number(item.currentValue);

          card.isModified = false;
          this.submittedParameters.add(`${relayId}-${card.parameter}`);
        });

        const etilogId = relay.etilog_id.trim();
        let blockPath = relay.device_id.split("-").join("/");

        const topicValue = `control/${this.getSelectedPlantId}/${etilogId}/relay/${blockPath}`;
        this.$mqtt.publish(topicValue, JSON.stringify(payload));
        console.log(JSON.stringify(this.pendingRelayParameterSubmission, null, 4), "PUBLISHED TO TOPIC WITH PAYLOAD:", topicValue, 'PAYLOAD **()**', payload);
      }

    },
    async getVcbList() {
      const response = await Controlling.getV2VcbList(this.getSelectedPlantId);
      this.vcbList = response.data.message;
      this.vcbList.forEach((el) => {
        this.$set(this.vcbConnected, el.etilog_id, el.apic_connected);
        this.$set(this.vcbStatus, el.device_id, el.state);
        this.$set(this.vcbSwitchMode, el.device_id, "N/A");
      });
    },
    async getVcbSwitchMode() {
      try {
        const response = await Controlling.getVcbSwitchMode(
          this.getSelectedPlantId
        );
        let list = response.data.message;
        list.forEach((el) => {
          let mode = "";
          if (el.remote == 1 && el.local == 0) {
            mode = "Remote";
          }

          if (
            (el.remote == 0 && el.local == 1) ||
            (el.remote == 1 && el.local == 1)
          ) {
            mode = "Local";
          }

          if (el.remote == null && el.local == null) {
            mode = "N/A";
          }
          this.$set(this.vcbSwitchMode, el.id, mode);
        });
      } catch (err) {
        console.log(err, "ERROR **()**");
      }
    },
    async insertLog(param) {
      await Controlling.insertEventLog(param);
    },
    handleVcbToggle(e, item) {
      const id = `${item.device_id}-${item.name}`;
      e.preventDefault();
      const tag = document.getElementById(id);

      if (tag.classList.contains("disabled")) {
        return;
      }
      this.handleVcbClick(item);
    },
    handleParamInput(value, item, relayId) {
      item.isModified = true;
      this.enableRelaySubmit(relayId);
      this.validateParameterValue(`${relayId}-${item.parameter}`, value);
    },
    getParamError(relayId, parameter) {
      const error = this.parameterErrors[`${relayId}-${parameter}`];
      return error ? [error] : [];
    },
    getConnectionIcon(isConnected) {
      if (isConnected) {
        return this.isDark
          ? require('@/assets/connection/internet_connected.svg')
          : require('@/assets/connection/internet_connected_light.svg');
      }
      return this.isDark
        ? require('@/assets/connection/no_internet.svg')
        : require('@/assets/connection/no_internet_light.svg');
    },
  },
  watch: {
    async getSelectedPlantId() {
      this.unsubscribeToTopics();
      this.listenToMqttTopics();

      await this.getVcbList();
      await this.getVcbSwitchMode();
      await this.getRelayList();
      this.submittedParameters = new Set();
      this.selectedParametersByRelay = {};
      this.parameterCardsByRelay = {};
      this.modifiedParametersByRelay = {};
      this.parameterErrors = {};
      this.relayConnected = {};
    },

    selectedParametersByRelay: {
      handler(newVal) {
        for (let relayId in newVal) {
          this.createParameterCardsForRelay(relayId);
        }
      },
      deep: true
    }
  },
};
</script>

<style scoped>
.relay-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
}

.relay-item {
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 6px;
  box-shadow: 0px 4px 4px rgba(126, 158, 247, 0.418);
}

.custom-border {
  border: 2px solid rgb(154, 154, 156);
  border-radius: 4px;
  padding: 16px;
}

.relay-item-card {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  border-radius: 8px;
}

.relay-vcb-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.relay-vcb-list>div {
  flex: 0 0 calc(25% - 12px);
  max-width: calc(25% - 12px);
}

@media (max-width: 1264px) {
  .relay-vcb-list>div {
    flex: 0 0 calc(33.33% - 12px);
    max-width: calc(33.33% - 12px);
  }
}

@media (max-width: 960px) {
  .relay-vcb-list>div {
    flex: 0 0 calc(50% - 12px);
    max-width: calc(50% - 12px);
  }
}

@media (max-width: 600px) {
  .relay-vcb-list>div {
    flex: 0 0 100%;
    max-width: 100%;
  }
}

.relay-vcb-item {
  flex: 0 1 calc(50% - 6px);
  min-width: 250px;
}

@media (max-width: 1200px) {
  .relay-vcb-item {
    flex: 0 1 calc(100% - 0px);
    min-width: 200px;
  }
}

@media (max-width: 768px) {
  .relay-vcb-item {
    flex: 0 1 100%;
  }

  .relay-container {
    padding: 8px;
    gap: 16px;
  }
}

.relay-content-wrapper {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  width: 100%;
}

@media (max-width: 1200px) {
  .relay-content-wrapper {
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  }
}

@media (max-width: 768px) {
  .relay-content-wrapper {
    grid-template-columns: 1fr;
  }
}

.custom-divider {
  background-color: #334079;
}

.toggle {
  position: relative;
  display: block;
  margin: 0 auto;
  width: 90px;
  height: 40px;
  outline: 0;
  text-decoration: none;
  border-radius: 5px;
  border: 2px solid #546e7a;
  background-color: var(--v-bg-base);
  transition: all 500ms;
}

.param-card {
  height: auto;
  min-height: 220px;
  max-height: 350px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 10px;
}

.chip-selection {
  background: rgba(40, 50, 90, 0.6);
}

 .theme--light .chip-selection  {
  background: rgba(0, 0, 0, 0.12);
 }

.param-card-error {
  border-color: #ff5252 !important;
  box-shadow: 0 0 15px rgba(255, 82, 82, 0.3) !important;
  background: rgba(255, 82, 82, 0.05);
}

.param-card-text {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding: 16px !important;
}

.param-title {
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.param-range {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
}

.range-text {
  margin: 0 4px;
}

.theme--light .range-text, .range-divider{
  color: rgba(0, 0, 0, 0.7);
}

.range-divider {
  margin: 0 8px;
}

.param-input {
  margin-top: 12px;
}

.param-input ::v-deep .v-input__control {
  background: rgba(165, 33, 33, 0.05);
  border-radius: 6px;
}

.param-input ::v-deep input {
  color: #ffffff;
  font-weight: 500;
  text-align: center;
}

.param-input ::v-deep input::placeholder {
  color: rgba(255, 255, 255, 0.5);
}

.param-input ::v-deep .v-input__slot {
  padding: 8px 12px;
}

.param-input ::v-deep .v-messages__message {
  color: #ff5252 !important;
  font-size: 12px;
  font-weight: 600;
  margin-top: 4px;
}

.param-input ::v-deep .v-input--is-focused.v-input--has-error input {
  color: #ff5252 !important;
}

.param-input ::v-deep .v-input--has-error .v-input__control input {
  border-color: #ff5252;
}

.button-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (max-width: 768px) {
  .param-title {
    font-size: 14px;
  }

  .param-card {
    min-height: 250px;
  }

  .button-container {
    flex-wrap: wrap;
  }
}

.theme--dark .param-card {
  background: rgba(15, 27, 76, 0.5);
}

.theme--dark .param-card-error {
  background: rgba(255, 82, 82, 0.1);
}

.theme--light .param-card {
  background: rgba(194, 198, 216, 0.1);
  border-color: rgb(130, 150, 230) !important;
}

.theme--light .param-card-error {
  background: rgba(255, 82, 82, 0.08);
  border-color: #ff5252 !important;
}

.theme--light .param-title {
  color: #000000;
}

.disabled {
  opacity: 0.3;
}

.disabled:hover {
  cursor: not-allowed;
}

.theme--dark .toggle:active {
  background-color: #1e272e;
}

.theme--light .toggle:active {
  background-color: #455a64;
}

.toggle:hover:not(.toggle--moving):after {
  background-color: #455a64;
}

.toggle:after {
  display: block;
  position: absolute;
  top: 4px;
  bottom: 4px;
  left: 4px;
  width: calc(50% - 4px);
  line-height: 25px;
  text-align: center;
  text-transform: uppercase;
  font-size: 16px;
  color: white;
  background-color: #000427;
  border: 2px solid;
  transition: all 500ms;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.3);
}

.theme--light .toggle:after {
  background-color: #fff;
}

.toggle--on:after {
  content: "On";
  border-radius: 5px 3px 3px 5px;
  color: #3cb371;
}

.toggle--off:after {
  content: "Off";
  border-radius: 3px 5px 5px 3px;
  transform: translate(100%, 0);
  color: #ff5252;
}

.toggle--moving {
  background-color: #1e272e;
}

.theme--light .toggle--moving {
  background-color: #455a64;
}

.toggle--moving:after {
  color: transparent;
  border-color: #4f6c7a;
  background-color: #2b3d44;
  transition: color 0s, transform 500ms, border-radius 500ms,
    background-color 500ms;
}

.custom-data-table {
  height: 71vh;
  overflow-y: auto;
  border-radius: 8px !important;
  border: 1px solid #334079;
}

.custom-data-table thead th:not(:last-child),
.custom-data-table tbody td:not(:last-child) {
  border-right: 1px solid #334079;
}

.custom-data-table thead th {
  height: 48px;
  font-size: 14px;
  font-weight: 700 !important;
}

.custom-data-table th {
  z-index: 1;
  position: sticky;
  top: 0;
}

.theme--dark .custom-data-table thead th {
  color: #fff !important;
}

.theme--light .custom-data-table thead th {
  color: #000 !important;
}

.relay-header {
  border-left: 4px solid #829fff;
  border-radius: 8px;
  color: #ffffff;
  font-size: 16px;
  font-weight: 700;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  letter-spacing: 0.5px;
}

.theme--light .relay-header {
  color: #333;
  border-left-color: #5064e6;
}

.glass-dialog {
  backdrop-filter: blur(10px);
}

.v-card {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1) !important;
}

.param-card {
  background: rgba(40, 50, 90, 0.6) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.theme--light .param-card {
  background: rgba(255, 255, 255, 0.9) !important;
  border-color: rgba(0, 0, 0, 0.1) !important;
}

.toggle {
  border-color: #546e7a;
}
</style>